export default function NoResult() {
  return <div style={{ textAlign: 'center' }}>No Result</div>;
}
